export const AUTHORIZATION = "Authorization";
export const CURRENCY = "Currency";
export const RESIDENT_CODE = "ResidentCode";
export const LANGUAGE = "Language";
export const PRIVACY_POLICE = "PrivacyPolice";
export const LOCALIZATION = "Localization";
